import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'fc-progress-bar',
  template: `
    <div
      class="relative w-full h-8 bg-secondary-100 rounded-sm overflow-hidden"
    >
      <div
        class="h-full bg-primary-500 rounded-sm transition-all duration-300"
        [style.width]="progressPercentage()"
      ></div>
    </div>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  progress = input.required<number>();

  readonly progressPercentage = computed(() => `${this.progress()}%`);
}
